import classNames from 'classnames';
import { map, get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Button from 'components/Button';
import Carousel from 'components/Carousel';
import { Grid, Cell } from 'components/Grid';
import { SecondaryHeading, TertiaryHeading } from 'components/Headings';
import Image from 'components/ImageV2';
import RichText from 'components/RichText';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

const FeaturedSlideShowMobile = ({
  slides,
  heading,
  activeSlideIndex,
  handleOnChange,
  trackOnClick,
}) => {
  return (
    <div className="FeaturedSlideShowMobile">
      <div className="FeaturedSlideShowMobile__carousel-wrapper">
        <SecondaryHeading className="FeaturedSlideShowMobile__header">{heading}</SecondaryHeading>
        <Carousel
          currentSlide={activeSlideIndex}
          onChange={currentSlide => handleOnChange(currentSlide)}
          options={{ loop: false }}
        >
          {map(slides, (slide, index) => (
            <div key={index} className="FeaturedSlideShowMobile__slide">
              <Grid>
                <Cell smallUp={{ columns: 12 }}>
                  <div className="FeaturedSlideShowMobile__image-wrapper">
                    <Image
                      className="FeaturedSlideShowMobile__image"
                      src={get(slide, ['featuredImagePortrait', 'file', 'url'])}
                      alt={get(slide, ['featuredImagePortrait', 'description'])}
                      width={get(slide, [
                        'featuredImagePortrait',
                        'file',
                        'details',
                        'image',
                        'width',
                      ])}
                      height={get(slide, [
                        'featuredImagePortrait',
                        'file',
                        'details',
                        'image',
                        'height',
                      ])}
                    />
                  </div>
                </Cell>
                <Cell smallUp={{ columns: 12 }}>
                  <div
                    className={classNames('FeaturedSlideShowMobile__content-wrapper', {
                      'FeaturedSlideShowMobile__content-wrapper--active':
                        activeSlideIndex === index,
                    })}
                  >
                    <TertiaryHeading className="FeaturedSlideShowMobile__heading">
                      {get(slide, 'featuredHeading')}
                    </TertiaryHeading>
                    <RichText
                      className="FeaturedSlideShowMobile__quote"
                      content={get(slide, 'featuredSubtext')}
                    />
                    <Button
                      className="FeaturedSlideShowMobile__shop-button"
                      linkTo={get(slide, ['cta', 'url'])}
                      onClick={trackOnClick}
                      isFullWidth
                    >
                      {get(slide, ['cta', 'text'])}
                    </Button>
                  </div>
                </Cell>
              </Grid>
            </div>
          ))}
        </Carousel>
      </div>
      <style jsx>
        {`
          .FeaturedSlideShowMobile {
            position: relative;
            overflow: hidden;
          }

          .FeaturedSlideShowMobile__carousel-wrapper {
            padding: 0 ${Theme.get('spacing') * 4}px;
          }

          .FeaturedSlideShowMobile__slide {
            margin: 0 ${Theme.get('spacing')}px;
            height: 100%;
          }

          .FeaturedSlideShowMobile__content-wrapper {
            padding-top: ${Theme.get('spacing') * 5}px;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            opacity: 0;
          }

          .FeaturedSlideShowMobile__content-wrapper--active {
            transition: opacity ${Theme.get('transition-duration-ms')};
            opacity: 1;
          }

          @media ${mediumUp} {
            .FeaturedSlideShowMobile__carousel-wrapper {
              padding-right: ${Theme.get('spacing') * 14}px;
              padding-left: ${Theme.get('spacing') * 6}px;
            }
          }
        `}
      </style>
      <style jsx global>
        {`
          .FeaturedSlideShowMobile__header.typography--secondary-heading {
            padding-bottom: ${Theme.get('spacing') * 4}px;
          }

          .FeaturedSlideShowMobile__heading.typography--tertiary-heading {
            padding-bottom: ${Theme.get('spacing') * 3}px;
          }

          .FeaturedSlideShowMobile__subtext.Paragraph {
            padding-bottom: ${Theme.get('spacing') * 5}px;
            margin-bottom: 0;
          }

          .FeaturedSlideShowMobile__image.ImageV2 {
            height: 100%;
          }

          .FeaturedSlideShowMobile__carousel-wrapper .Carousel {
            overflow: visible !important;
            margin: 0 -${Theme.get('spacing')}px;
          }
        `}
      </style>
    </div>
  );
};

FeaturedSlideShowMobile.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  heading: PropTypes.string.isRequired,
  activeSlideIndex: PropTypes.number,
  handleOnChange: PropTypes.func,
  trackOnClick: PropTypes.func,
};

FeaturedSlideShowMobile.defaultProps = {
  activeSlideIndex: 0,
  handleOnChange: () => {},
  trackOnClick: () => {},
};

export default FeaturedSlideShowMobile;
